import { format, parseISO } from "date-fns";
import { ru } from "date-fns/locale";
import type {
  TourCard,
  TourDateGroup as TourDateGroupType,
} from "../../types/history";
import { PERIOD_LABELS, PERIOD_ORDER } from "../../constants/periods";
import {
  TourCard as TourCardView,
  TourPlaceholderCard,
} from "../tours-cards-section/TourSlotCard";

interface TourDateGroupProps {
  group: TourDateGroupType;
  isToday: boolean;
  onOpen: (card: TourCard) => void;
}

export function TourDateGroup({ group, isToday, onOpen }: TourDateGroupProps) {
  const heading = format(parseISO(group.date), "d MMMM yyyy", { locale: ru });

  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2">
        <h2 className="text-sm font-semibold capitalize">{heading}</h2>
        {isToday && (
          <span className="text-xs text-muted-foreground">Сегодня</span>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
        {PERIOD_ORDER.map((period) => {
          const slot = group.slots[period];
          return (
            <div key={period} className="space-y-2">
              <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {PERIOD_LABELS[period]}
              </span>
              <div className="space-y-3">
                {slot.card ? (
                  <TourCardView card={slot.card} onOpen={onOpen} />
                ) : (
                  slot.placeholder && (
                    <TourPlaceholderCard placeholder={slot.placeholder} />
                  )
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
